function ReviewService(ApiService){
  'ngInject';

  const service = {};

  service.getReview = function(url, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.updateReview = function(orgId,editUserForm, callbackFunc) {
    ApiService.put(`/organizations/${orgId}/review_matrices/${editUserForm.id}.json`, editUserForm, callbackFunc);
  };

  service.getReviewStatuses = function(url, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.tryNow = function(orgId, date, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/review_matrices/try_now.json`, {date: date}, callbackFunc);
  };

  service.tryNowDashboard = function(date, callbackFunc) {
    ApiService.post(`/organization_review_statuses/try_now.json`, {date: date}, callbackFunc);
  };

  return service;
}
export default {
  name: 'ReviewService',
  fn: ReviewService
};
